import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react/components/shared/Icon";
import { ROOM_STATUS } from "@circle-react/helpers/liveStreamRoomHelpers";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

interface LiveStreamStatusProps {
  status: (typeof ROOM_STATUS)[keyof typeof ROOM_STATUS];
}
export const LiveStreamStatus = ({ status }: LiveStreamStatusProps) => {
  const statusMapObj = {
    [ROOM_STATUS.INITIALIZING]: t("live_streams.status.initializing"),
    [ROOM_STATUS.BACKSTAGE]: t("live_streams.status.backstage"),
    [ROOM_STATUS.LIVE]: t("live_streams.status.live"),
    [ROOM_STATUS.ENDED]: t("live_streams.status.finished"),
    [ROOM_STATUS.CLOSING]: t("live_streams.status.closing"),
  };

  const renderIcon = () => {
    const statusIndicator = () => (
      <div
        className={classNames({
          "text-[#4262f0]": status === ROOM_STATUS.BACKSTAGE,
          "text-[#e02f2f]": status === ROOM_STATUS.LIVE,
          "text-[#61C878]": status === ROOM_STATUS.ENDED,
        })}
      >
        <Icon size={6} type="middot" />
      </div>
    );
    const statusesWithIcons: (typeof ROOM_STATUS)[keyof typeof ROOM_STATUS][] =
      [ROOM_STATUS.BACKSTAGE, ROOM_STATUS.LIVE, ROOM_STATUS.ENDED];

    if (statusesWithIcons.includes(status)) {
      return statusIndicator();
    }
    return null;
  };

  return (
    <div className="flex items-center">
      {renderIcon()}
      {statusMapObj[status] || ""}
    </div>
  );
};
